import SidePanel from './SidePanel.component';

export default SidePanel;
